/* import __COLOCATED_TEMPLATE__ from './dropdown.hbs'; */
import UserFieldBase from "./base";
import TEMPLATE from "./dropdown.hbs";
import { setComponentTemplate } from "@ember/component";
export default class UserFieldDropdown extends UserFieldBase {}
setComponentTemplate(TEMPLATE, UserFieldDropdown);